module.exports = __webpack_public_path__ + "img/5.fd4b3bff.png";